export const initialState = {
  healthConditionGroups: [],
  healthConditionGroup: {},
  loading: false
};
